export enum LogInMachineNodes {
  IDLE = 'IDLE',
  VERIFIED = 'VERIFIED',
}
